export default "__VITE_ASSET__Bc3e6JIi__"